import { useState } from "react";
import * as Icon from "react-feather";

import Button from "../common/Button";
import Card from "../common/Card";
import Form from "../common/Form";

import logo from "./../../assets/images/empower-logo-box.png";

import { connect } from "react-redux";
import { AuthActionCreators } from "../../store/actions/auth";

const initialState = {
  errorMessage: null,
  infoMessage: null,
  errors: {
    email: null,
    name: null,
    password: null,
  },
  loading: false,
  values: {
    email: "",
    name: "",
    password: "",
  },
};

const AuthRegister = ({ register }) => {
  const [errorMessage, setErrorMessage] = useState(initialState.errorMessage);
  const [infoMessage, setInfoMessage] = useState(initialState.infoMessage);
  const [errors, setErrors] = useState(initialState.errors);
  const [loading, setLoading] = useState(initialState.loading);
  const [email, setEmail] = useState(initialState.values.email);
  const [password, setPassword] = useState(initialState.values.password);
  const [name, setName] = useState(initialState.values.name);

  const onBlur = (e) => {
    e && e.preventDefault();
    const errorsVar = errors;
    if (!e.target.value.length) {
      errorsVar[e.target.name] = "This is a required field!";
    } else {
      errorsVar[e.target.name] = null;
    }
    setErrors(errorsVar);
  };

  const onChange = (e) => {
    e && e.preventDefault();
    if (e.target.name === "email") setEmail(e.target.value);
    if (e.target.name === "password") setPassword(e.target.value);
    if (e.target.name === "name") setName(e.target.value);
  };

  const onSubmit = (e) => {
    e && e.preventDefault();
    setErrors(initialState.errors);
    setErrorMessage(initialState.errorMessage);
    setLoading(true);
    if (email === "" || name === "" || password === "") {
      setErrorMessage("Please fill the required inputs");
      setLoading(false);
    } else {
      setInfoMessage("Please wait while our team activate your account");
      setLoading(false);
      register({
        email: email.trim(),
        name: name.trim(),
        password: password.trim(),
      });
    }
  };
  return (
    <div className="max-w-sm m-auto h-screen flex flex-col">
      <div className="my-auto">
        <img
          src={logo}
          width="150"
          className="mb-3 m-auto"
          alt="Empower Logo"
        />
        {errorMessage && (
          <div
            className="bg-red-100 border-l-4 border-red-500 rounded-b text-red-900 px-4 py-3 shadow mb-3"
            role="alert"
          >
            <div className="flex">
              <div className="py-1">
                <Icon.Info className="h-6 w-6 text-red-500 mr-4" />
              </div>
              <div>
                <p className="font-bold">Register Failed</p>
                <p className="text-sm">{errorMessage}</p>
              </div>
            </div>
          </div>
        )}
        {infoMessage && (
          <div
            className="bg-blue-100 border-l-4 border-blue-500 rounded-b text-blue-900 px-4 py-3 shadow mb-3"
            role="alert"
          >
            <div className="flex">
              <div className="py-1">
                <Icon.Info className="h-6 w-6 text-blue-500 mr-4" />
              </div>
              <div>
                <p className="font-bold">Your account has registered!</p>
                <p className="text-sm">{infoMessage}</p>
              </div>
            </div>
          </div>
        )}
        <Card className="p-2">
          <Card.Body>
            <span className="block text-lg mb-5">Create an account</span>
            <Form>
              <Form.FormTextInput
                name="name"
                label="Full Name"
                placeholder="Full name"
                onChange={onChange}
                onBlur={onBlur}
                value={name}
                error={errors && errors.name}
              />
              <Form.FormTextInput
                name="email"
                label="Email Address"
                placeholder="Enter email"
                onChange={onChange}
                onBlur={onBlur}
                value={email}
                error={errors && errors.email}
                type="email"
              />
              <Form.FormTextInput
                name="password"
                type="password"
                label="Password"
                placeholder="Password"
                onChange={onChange}
                onBlur={onBlur}
                value={password}
                error={errors && errors.password}
              />
              <Button
                className="w-full"
                color="login"
                onClick={onSubmit}
                disabled={loading}
                loading={loading}
                type="submit"
              >
                Create Account
              </Button>
            </Form>
          </Card.Body>
        </Card>
        <p className="text-center text-gray-600 text-sm">
          Already have an account?{" "}
          <a href="/auth/login" className="font-bold text-blue-700">
            Login
          </a>
        </p>
      </div>
    </div>
  );
};

export default connect(null, (dispatch) => ({
  register: (user) => dispatch(AuthActionCreators.register(user)),
}))(AuthRegister);
